import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0.249023 11.1906V13.4706C0.249023 13.6806 0.414023 13.8456 0.624023 13.8456H2.90402C3.00152 13.8456 3.09902 13.8081 3.16652 13.7331L11.3565 5.55062L8.54402 2.73813L0.361524 10.9206C0.286524 10.9956 0.249023 11.0856 0.249023 11.1906Z",
		fill: "#3C59F6"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.5315 2.31813L11.7765 0.563125C11.484 0.270625 11.0115 0.270625 10.719 0.563125L9.34652 1.93562L12.159 4.74813L13.5315 3.37563C13.824 3.08313 13.824 2.61063 13.5315 2.31813Z",
		fill: "#3C59F6"
	})]
});
export default SvgPen;
